import { lazy } from 'react'

export const UpdateProductModalAsync = lazy(() =>
    import('./UpdateProductModal').then((module) => ({
        default: module.UpdateProductModal,
    }))
)
